import { TerminalSettingsService } from "./../../terminal/terminal-settings.service";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { CartHelperService, ICart } from "@app/store/cart/cart-helper-service";
import { PaymentMethod } from "@shared/AppEnums";
import { AppComponentBase } from "@shared/common/app-component-base";
import { AppSessionService } from "@shared/common/session/app-session.service";
import {
    CouponDto,
    CreateOrEditMemberAnnuityDto,
    CreateOrEditOrderDto,
    CreateOrEditRegistrationByAdminDto,
    CreateOrEditRegistrationDto,
    CreditCardPaymentDto,
    DebitCardPaymentDto,
    EntityDtoOfInt64,
    MemberAnnuityDto,
    MemberAnnuityOrderItemDto,
    MemberAnnuityServiceProxy,
    MemberAnnuityUserEditDto,
    OrderDto,
    OrdersServiceProxy,
    OrderUserEditDto,
    PaymentDto,
    PaymentMethodsServiceProxy,
    ReceivablePaymentMethodPermissionDto,
    RegistrationOrderItemDto,
    RegistrationsServiceProxy,
    RegistrationUserEditDto,
    UserAddressDto,
} from "@shared/service-proxies/service-proxies";
import { AgentSitefService } from "congress/shared/layout/checkout/agent-sitef/agent-sitef.service";
import * as moment from "moment";
import { ModalDirective } from "ngx-bootstrap";
import { AgentSitefComponent } from "../agent-sitef/agent-sitef.component";
import { CongressWarnModalComponent } from "../../congress-warn-modal/congress-warn-modal.component";

@Component({
    selector: "checkout-modal",
    templateUrl: "./checkout-modal.component.html",
    styleUrls: ["./checkout-modal.component.css"],
})
export class CheckoutModalComponent extends AppComponentBase {
    @ViewChild("checkoutModal") modal: ModalDirective;
    @ViewChild('congressWarnModal') congressWarnModal: CongressWarnModalComponent;
    @ViewChild("modalbody") modalbody: ElementRef;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    public agentSitef: AgentSitefComponent;

    @ViewChild("agentSitef") set content(content: AgentSitefComponent) {
        if (content) {
            // initially setter gets called with undefined
            this.agentSitef = content;
        }
    }

    public active = false;
    public saving = false;
    public paying = false;
    public loaded = false;
    public onLocal = false;

    paymentMethod = PaymentMethod;

    orderId = 0;
    _registrationId = 0;
    _memberAnnuityId = 0;

    userLogged = this.appSession.user;
    order: CreateOrEditOrderDto = undefined;
    payment = new PaymentDto();
    creditCardPaymentMethodPermission = undefined;
    debitCardPaymentMethodPermission = undefined;
    paymentMethodSelected = undefined;
    creditCardPayment = undefined;
    cart: ICart = undefined;
    cartUser: OrderUserEditDto = undefined;

    items = [];
    paymentMethods = [];
    eventTypes = [];

    constructor(
        injector: Injector,
        private _router: Router,
        private changeDetector: ChangeDetectorRef,
        private _appSessionService: AppSessionService,
        private _cartHelperService: CartHelperService,
        public _sitefAgentService: AgentSitefService,
        private _settingsService: TerminalSettingsService,
        private _ordersService: OrdersServiceProxy,
        private _registrationsService: RegistrationsServiceProxy,
        private _memberAnnuityService: MemberAnnuityServiceProxy,
        private _paymentMethodsService: PaymentMethodsServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadCart();
        if (localStorage.getItem("event-types")){
            this.eventTypes = JSON.parse(localStorage.getItem("event-types")) as Array<string>;
            this.eventTypes = this.eventTypes.length > 2 ? this.eventTypes.sort().slice(0, 2) : this.eventTypes.sort();
        }
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $("tabset ul.nav").addClass("m-tabs-line");
        $("tabset ul.nav li a.nav-link").addClass("m-tabs__link");

        //Ajuste para melhorar performance da modal
        this.modal.config.animated = false;
        this.modal.config.backdrop = "static";
    }

    show(): void {
        this.modal.show();
        this.initialLoad();
        this.showRegistrationMessage();

    }

    initialLoad(){
        this.loadCart();
        this.loadOrder();
        this.loadPaymentMethods();

        this.paying = false;
        this.active = true;

        this.getCart();
    }

    onShown(): void {
        this.triggerFalseClick();
    }

    close(): void {
        this.active = false;
        this.triggerFalseClick();
        this.modal.hide();

        this.paying = false;
        this.orderId = 0;
        this._registrationId = 0;
        this._memberAnnuityId = 0;

        this.order = undefined;
        this.creditCardPaymentMethodPermission = undefined;
        this.debitCardPaymentMethodPermission = undefined;
        this.paymentMethodSelected = undefined;
        this.creditCardPayment = undefined;


        this.items = [];
        this.paymentMethods = [];
    }

    showRegistrationMessage(){

        if (localStorage.getItem("showRegistrationMessage")){
            this.notify.error(
                "Caso efetue a inscrição na categoria incorreta, o departamento de eventos entrará em contato para regularização: acerto do valor e/ou cobrança de documentação. O certificado de participação somente será disponibilizado aos participantes com inscrição regularizada",
                "Atenção",
                {
                    timeOut: 30000,
                    closeButton: true,
                    onclick: (e) => {
                        localStorage.removeItem("showRegistrationMessage");
                    },
                    onCloseClick: (e) => {
                        localStorage.removeItem("showRegistrationMessage");
                    }
                }
            );
        }
    }

    pay(cupomFiscal) {
        if (!this.paymentMethodSelected)
            this.message.warn(
                "Método de pagamento inválido",
                "Selecione o método de pagamento!"
            );

        this.paying = true;
        this.changeDetector.detectChanges();

        let terminalSettings = this._settingsService.getSettings();
        let paymentMethod =
            this.paymentMethodSelected.paymentMethodType ==
            PaymentMethod.DebitCard
                ? 2
                : 3; //2: débito; 3= crédito

        this.agentSitef.start(
            1,
            paymentMethod,
            cupomFiscal,
            this.payment.totalPaid.toFixed(2),
            this.creditCardPayment.installments
                ? Number(this.creditCardPayment.installments)
                : 1,
            terminalSettings.operator,
            terminalSettings.initParams,
            terminalSettings.initParams,
            terminalSettings.ipSiTef,
            terminalSettings.enterprise,
            terminalSettings.name
        );
    }

    finishPayment(status: any) {
        if (status == 0) {
            this.agentSitef._statusTitle = "Pagamento realizado com sucesso. Aguarde...";

            this.save(false, true);
        } else {
            this.paying = false;
        }
    }

    //load order items
    loadOrder(): void {

        this.order = new CreateOrEditOrderDto();
        this.order.payment = new PaymentDto();
        this.order.user =  this.cart.user;
        this.order.user.phones = undefined;
        this.order.user.emails = undefined;
        this.order.order = new OrderDto();
        this.order.order.amount = this.cart ? this.cart.total : 0;
        this.order.order.paymentMethodPermissions = [];
        this.order.order.memberAnnuities = [];
        this.order.order.registrations = [];

        this.cartUser = this.order.user;
        this.cartUser.address =  Object.assign(new UserAddressDto, this.cartUser.address);
        this.cartUser.emails = [];
        this.cartUser.phones = [];

        this.cart.memberAnnuities.forEach((memberAnnuity) => {
            let item = new MemberAnnuityOrderItemDto();
            item.annuityId = memberAnnuity.memberAnnuity.annuityId;
            item.categoryDeadLineId = memberAnnuity.categoryDeadline.id;

            this.order.order.memberAnnuities.push(item);
        });

        this.cart.registrations.forEach((registration) => {
            let item = new RegistrationOrderItemDto();
            item.eventId = registration.registration.eventId;
            item.categoryDeadLineId = registration.categoryDeadline.id;
            item.note = registration.registration.note;

            if (registration.registration.coupon) {
                item.coupon = new CouponDto();
                item.coupon.code = registration.registration.coupon.code;
                //item.coupon.couponGroupId = registration.registration.coupon.group;
            }

            this.order.order.registrations.push(item);
        });

        if (this.order.order.amount == 0 || this.cart.onLocal) {
            this.payment.totalPaid = this.cart.total;
            this.payment.appliedDiscount = 0;
        }
    }

    //load allowed payment methods
    loadPaymentMethods(): void {
        var eventIds = this.order.order.registrations.map(
            ({ eventId }) => eventId
        );
        var eventCategoriesIds = this.order.order.registrations.map(
            ({ categoryDeadLineId }) => categoryDeadLineId
        );
        var annuityId = this.order.order.memberAnnuities.map(
            ({ annuityId }) => annuityId
        )[0];
        var annuityCategoriesIds = this.order.order.memberAnnuities.map(
            ({ categoryDeadLineId }) => categoryDeadLineId
        );

        this._paymentMethodsService
            .getOrderPaymentMethodsForSelect(
                undefined,
                true,
                false,
                annuityId,
                annuityCategoriesIds,
                eventIds,
                eventCategoriesIds
            )
            .subscribe((result) => {
                this.paymentMethods = result.items;
                this.loadPaymentMethodPermissions();
            });
    }

    //load allowed payment methods
    loadPaymentMethodPermissions(): void {
        this.paymentMethods.forEach((x) => {
            let permission = new ReceivablePaymentMethodPermissionDto();
            permission.isAllowed = true;
            permission.fee = x.fee;
            permission.percentDiscount = x.percentDiscount;
            permission.paymentMethodId = x.id;

            this.order.order.paymentMethodPermissions.push(permission);

            if (x.paymentMethodType == PaymentMethod.CreditCard) {
                this.creditCardPaymentMethodPermission = x;
                // this.creditCardPaymentMethodPermission.maxFee = 2
            } else if (x.paymentMethodType == PaymentMethod.DebitCard) {
                this.debitCardPaymentMethodPermission = x;
            }

            this.loaded = true;
        });
    }

    //Get cart from storage and refresh
    getCart(checkOnLocal?: boolean): void {
        this.cart = this._cartHelperService.getCart();
        abp.event.trigger("app.cart.refresh");

        if (checkOnLocal) this.onLocal = this.cart && this.cart.onLocal;
    }

    //register refresh cart event
    registerToEvents() {
        abp.event.on("app.cart.refresh", () => {
            this.loadCart();
        });
    }

    //load cart itens
    loadCart(): void {
        this.cart = this._cartHelperService.loadCart();
        this.cartUser = this.cart.user;

        let cartItems = [];

        this.cart.memberAnnuities.forEach((x) => {
            cartItems.push({
                text: x.annuity.year,
                value: x.memberAnnuity.payments[0].totalPaid,
            });
        });
        this.cart.registrations.forEach((x) => {
            cartItems.push({
                text: x.event.name,
                value: x.registration.payments[0].totalPaid,
            });
        });

        this.items = [];
        for (let i = 0; i < cartItems.length && i < 3; i++) {
            this.items.push(cartItems[i]);
        }
    }

    //Remove Annuity item from bag
    removeMemberAnnuityFromBag(annuityId: number) {

        this._cartHelperService.removeMemberAnnuityById(annuityId);

        abp.event.trigger("app.cart.refresh");

        this._cartHelperService.updateUserCart(this.cartUser, false);
        this.cart = this._cartHelperService.getCart(this.onLocal);
        this.calculateTotalPaid();
        this.initialLoad();

    }

    //Remove Event item from bag
    removeRegistrationFromBag(item: number) {

        this._cartHelperService.removeRegistrationByEventId(item);

        abp.event.trigger("app.cart.refresh");
        this._cartHelperService.updateUserCart(this.cartUser, false);
        this.cart = this._cartHelperService.getCart(this.onLocal);
        this.calculateTotalPaid();
        this.initialLoad();


    }

    setPaymentMethod(method: any) {
        this.paymentMethodSelected = method;
        this.calculateValue();
    }

    calculateValue(): void {
        this.payment.paymentMethodId = this.paymentMethodSelected
            ? this.paymentMethodSelected.id
            : undefined;
        this.payment.appliedDiscount = 0;

        this.order.ticketPayment = undefined;
        this.order.creditCardPayment = undefined;
        this.order.debitCardPayment = undefined;
        this.order.payment = this.payment;
        this.order.user = this.cart.user;
        this.order.user.phones = undefined;
        this.order.user.emails = undefined;

        if (this.creditCardPayment == undefined) {
            this.creditCardPayment = new CreditCardPaymentDto();
            this.creditCardPayment.installments = 1;
        } else {
            this.creditCardPayment.creditCardBrand = undefined;
            this.creditCardPayment.installments = 1;
        }

        if(isNaN(this.order.payment.totalPaid))
           this.order.payment.totalPaid = this.calculateTotalPaid();

        this._ordersService.updateValues(this.order).subscribe((result) => {
            this.payment.totalPaid = result.payment.totalPaid;
            this.payment.appliedDiscount = result.payment.appliedDiscount;
        });
    }

    // Calculate Total Paid
    calculateTotalPaid(): number {
        this.payment.totalPaid = this.cart.total - this.payment.appliedDiscount;
        return this.payment.totalPaid;
    }

    save(justSave: boolean, finish?: boolean): void {
        this.saving = true;
        this.order.order.id = this.orderId > 0 ? this.orderId : undefined;
        this.order.order.amount = this.cart.total;
        this.order.order.discount = this.payment.appliedDiscount;
        this.order.order.netAmount =
            this.cart.total - this.payment.appliedDiscount;

        //Aprova as inscrições automaticamente
        this.order.autoApprove = finish;

        this.order.order.registrations.forEach((note) => {
            let registration = new CreateOrEditRegistrationDto();
            registration.note = note.note;
        });

        // this.order.order.registrations[0].amount = this.cart.total;
        // this.order.order.registrations[0].discount = this.payment.appliedDiscount;
        // this.order.order.registrations[0].netAmount = this.cart.total - this.payment.appliedDiscount;

        this.order.payment = undefined;
        this.order.creditCardPayment = undefined;
        this.order.debitCardPayment = undefined;

        if (
            this.paymentMethodSelected.paymentMethodType ==
            PaymentMethod.CreditCard
        ) {
            this.order.creditCardPayment = new CreditCardPaymentDto();
            this.order.creditCardPayment.paidDate = moment();
            this.order.creditCardPayment.cardExpirationDate = moment();
            this.order.creditCardPayment.cardNumber = "************";
            this.order.creditCardPayment.cpf = this.order.user.userName;
            this.order.creditCardPayment.creditCardBrand = this
                .creditCardPayment.creditCardBrand
                ? this.creditCardPayment.creditCardBrand
                : "Mastercard";
            this.order.creditCardPayment.holderName = this.order.user.name;
            this.order.creditCardPayment.securityCode = "123";
            this.order.creditCardPayment.numberOfInstallments =
                this.creditCardPayment.installments > 1
                    ? this.creditCardPayment.installments
                    : 1;
            this.order.creditCardPayment.paymentMethodId =
                this.paymentMethodSelected.id;
            this.order.creditCardPayment.totalPaid = this.payment.totalPaid;
            this.order.creditCardPayment.appliedDiscount =
                this.payment.appliedDiscount;
        } else if (
            this.paymentMethodSelected.paymentMethodType ==
            PaymentMethod.DebitCard
        ) {
            this.order.debitCardPayment = new DebitCardPaymentDto();
            this.order.debitCardPayment.paidDate = moment();
            this.order.debitCardPayment.cardExpirationDate = moment();
            this.order.debitCardPayment.cardNumber = "************";
            this.order.debitCardPayment.cpf = this.order.user.userName;
            this.order.debitCardPayment.cardBrand = this.creditCardPayment
                .creditCardBrand
                ? this.creditCardPayment.creditCardBrand
                : "Maestro";
            this.order.debitCardPayment.holderName = this.order.user.name;
            this.order.debitCardPayment.securityCode = "123";
            this.order.debitCardPayment.numberOfInstallments = 1;
            this.order.debitCardPayment.paymentMethodId =
                this.paymentMethodSelected.id;
            this.order.debitCardPayment.totalPaid = this.payment.totalPaid;
            this.order.debitCardPayment.appliedDiscount =
                this.payment.appliedDiscount;
        } else {
            this.order.payment = new PaymentDto();
            this.order.payment.totalPaid = this.payment.totalPaid;
            this.order.payment.appliedDiscount = this.payment.appliedDiscount;
            this.order.payment.paymentMethodId = this.payment.paymentMethodId;

            if (this.paymentMethodSelected)
                this.order.payment.paymentMethodId =
                    this.paymentMethodSelected.id;
        }

        this.order.onLocal = this.cart.onLocal;

        if (
            this.order.order.registrations.length == 1 &&
            this.order.order.memberAnnuities.length == 0
        ) {
            var registration = this.order.order.registrations[0];
            var newregistration = new CreateOrEditRegistrationByAdminDto();
            newregistration.id =
                this._registrationId > 0 ? this._registrationId : undefined;
            newregistration.eventId = registration.eventId;

            newregistration.user = new RegistrationUserEditDto();
            newregistration.user.id = this.cart.user.id;
            newregistration.user.name = this.cart.user.name;
            newregistration.user.nameForCredential =
                this.cart.user.nameForCredential;
            newregistration.user.userName = this.cart.user.userName;
            newregistration.user.emailAddress = this.cart.user.emailAddress;
            newregistration.user.address = this.cart.user.address;
            // newregistration.user.emails = this.cart.user.emails;
            // newregistration.user.phones = this.cart.user.phones;
            newregistration.user.member = this.cart.user.member;

            newregistration.onLocal = this.order.onLocal;

            newregistration.paymentMethodId = this.payment.paymentMethodId;
            newregistration.coupon = registration.coupon;
            newregistration.payments = new Array();

            if (this.order.ticketPayment) {
                newregistration.paymentMethodId =
                    this.order.ticketPayment.paymentMethodId;
                newregistration.ticketPayment = this.order.ticketPayment;
                newregistration.payments.push(this.order.ticketPayment);
            } else if (this.order.creditCardPayment) {
                newregistration.paymentMethodId =
                    this.order.creditCardPayment.paymentMethodId;
                newregistration.creditCardPayment =
                    this.order.creditCardPayment;
                newregistration.payments.push(this.order.creditCardPayment);
            } else if (this.order.debitCardPayment) {
                newregistration.paymentMethodId =
                    this.order.debitCardPayment.paymentMethodId;
                newregistration.debitCardPayment = this.order.debitCardPayment;
                newregistration.payments.push(this.order.debitCardPayment);
            } else {
                newregistration.paymentMethodId =
                    this.order.payment.paymentMethodId;
                newregistration.payments.push(this.order.payment);
            }

            newregistration.categoryDeadlineId =
                registration.categoryDeadLineId;

            newregistration.justSave = justSave;
            this.createRegistration(newregistration, finish);
        } else if (
            this.order.order.memberAnnuities.length == 1 &&
            this.order.order.registrations.length == 0
        ) {
            var memberAnnuity = this.order.order.memberAnnuities[0];
            var newMemberAnnuity = new CreateOrEditMemberAnnuityDto();
            newMemberAnnuity.annuity = new MemberAnnuityDto();
            newMemberAnnuity.annuity.id =
                this._memberAnnuityId > 0 ? this._memberAnnuityId : undefined;
            newMemberAnnuity.annuity.annuityId = memberAnnuity.annuityId;

            newMemberAnnuity.user = new MemberAnnuityUserEditDto();
            newMemberAnnuity.user.id = this.cart.user.id;
            newMemberAnnuity.user.name = this.cart.user.name;
            newMemberAnnuity.user.nameForCredential =
                this.cart.user.nameForCredential;
            newMemberAnnuity.user.userName = this.cart.user.userName;
            newMemberAnnuity.user.emailAddress = this.cart.user.emailAddress;
            newMemberAnnuity.user.address = this.cart.user.address;
            // newMemberAnnuity.user.emails = this.cart.user.emails;
            // newMemberAnnuity.user.phones = this.cart.user.phones;
            newMemberAnnuity.user.member = this.cart.user.member;

            newMemberAnnuity.onLocal = this.order.onLocal;

            //newMemberAnnuity.paymentMethodId = this.payment.paymentMethodId;
            newMemberAnnuity.annuity.payments = new Array();

            if (this.order.ticketPayment) {
                newMemberAnnuity.ticketPayment = this.order.ticketPayment;
                newMemberAnnuity.ticketPayment.paymentMethodId =
                    this.order.ticketPayment.paymentMethodId;
                newMemberAnnuity.annuity.payments.push(
                    this.order.ticketPayment
                );
            } else if (this.order.creditCardPayment) {
                newMemberAnnuity.creditCardPayment =
                    this.order.creditCardPayment;
                newMemberAnnuity.creditCardPayment.paymentMethodId =
                    this.order.creditCardPayment.paymentMethodId;
                newMemberAnnuity.annuity.payments.push(
                    this.order.creditCardPayment
                );
            } else if (this.order.debitCardPayment) {
                newMemberAnnuity.debitCardPayment = this.order.debitCardPayment;
                newMemberAnnuity.debitCardPayment.paymentMethodId =
                    this.order.debitCardPayment.paymentMethodId;
                newMemberAnnuity.annuity.payments.push(
                    this.order.debitCardPayment
                );
            } else {
                newMemberAnnuity.payment.paymentMethodId =
                    this.order.payment.paymentMethodId;
                newMemberAnnuity.annuity.payments.push(this.order.payment);
            }

            newMemberAnnuity.annuity.categoryDeadLineId =
                memberAnnuity.categoryDeadLineId;
            newMemberAnnuity.annuity.categoryDeadLine =
                memberAnnuity.categoryDeadLine;

            newMemberAnnuity.justSave = justSave;
            this.createMemberAnnuity(newMemberAnnuity, finish);
        } else {
            this.order.justSave = justSave;
            this.createOrEdit(finish);
        }
    }

    createOrEdit(finish?: boolean): void {
        this.order.onLocal = finish;
        this.order.sitefClientVoucher = localStorage.getItem("cupomClienteSitef");
        this.order.sitefStoreVoucher = localStorage.getItem("cupomLojaSitef");
        this.order.sitefTransactionData = localStorage.getItem("dadosSitef");

        this._ordersService
            .createOrEdit(this.order)
            .finally(() => {
                this.saving = false;
                this.clearSitefStorage();
            })
            .subscribe(
                (result) => {
                    if (result.orderId > 0) {
                        this.orderId = result.orderId;
                    }

                    if (!result.success) {
                        this.message.warn(this.l(result.message));
                    } else {
                        if (this.orderId > 0 && !finish) this.pay(this.orderId);
                        else if (finish) {

                            this.congressWarnModal.show('Compra finalizada!', `<h4 class='text-primary-congress'><strong>${this.userLogged.name.split(' ')[0]},</strong> sua compra foi finalizada com sucesso! <br>Comprovantes foram enviados para o seu endereço de e-mail cadastrado no sistema SAESP. <br>A SAESP agradece, bom evento!<br></h4><br><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.</h5>`, true, 'congresso/home');

                            this._cartHelperService.finalizeCart();
                            let input = new EntityDtoOfInt64();
                            input.id = result.orderId;
                            this.close();
                            this._router.navigate(["congresso/home"]);
                            this._ordersService
                                .sendConfirmPaymentEmail(input)
                                .subscribe((result) => {});
                            this.modalSave.emit(null);
                        }
                    }
                },
                (error) => {
                    // this.message.error(
                    //     "Ocorreu um erro ao salvar as informações da compra. Verifique se a compra foi concluída antes de tentar novamente.<br>" +
                    //         error,
                    //     "Falha"
                    // );
                    this.paying = false;
                }
            );
    }

    createRegistration(
        registration: CreateOrEditRegistrationByAdminDto,
        finish?: boolean
    ) {
        registration.onLocal = finish;
        registration.autoApprove = finish;
        registration.sitefClientVoucher = localStorage.getItem("cupomClienteSitef");
        registration.sitefStoreVoucher = localStorage.getItem("cupomLojaSitef");
        registration.sitefTransactionData = localStorage.getItem("dadosSitef");

        this._registrationsService
            .createOrEdit(registration)
            .finally(() => {
                this.saving = false;
                this.clearSitefStorage();
            })
            .subscribe(
                (result) => {
                    if (result.registrationId > 0) {
                        this._registrationId = result.registrationId;
                    }

                    if (!result.success) {
                        this.message.warn(this.l(result.message));
                    } else {
                        if (result.registrationId > 0 && !finish) {
                            this.pay(this._registrationId);
                        } else if (finish) {
                            this.congressWarnModal.show('Compra finalizada!', `<h4 class='text-primary-congress'><strong>${this.userLogged.name.split(' ')[0]},</strong> sua compra foi finalizada com sucesso! <br>Comprovantes foram enviados para o seu endereço de e-mail cadastrado no sistema SAESP. <br>A SAESP agradece, bom evento!<br></h4><br><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.</h5>`, true, 'congresso/home');

                            this._cartHelperService.finalizeCart();

                            let input = new EntityDtoOfInt64();
                            input.id = result.registrationId;

                            this.close();
                            this._router.navigate(["congresso/home"]);

                            this._ordersService
                                .sendConfirmPaymentEmail(input)
                                .subscribe((result) => {});
                            this.modalSave.emit(null);
                        }
                    }
                },
                (error) => {
                    // this.message.error(
                    //     "Ocorreu um erro ao salvar as informações da compra. Verifique se a inscrição foi concluída antes de tentar novamente.<br>" +
                    //         error,
                    //     "Falha"
                    // );
                    this.paying = false;
                }
            );
    }

    createMemberAnnuity(
        annuity: CreateOrEditMemberAnnuityDto,
        finish?: boolean
    ) {
        annuity.onLocal = finish;
        annuity.sitefClientVoucher = localStorage.getItem("cupomClienteSitef");
        annuity.sitefStoreVoucher = localStorage.getItem("cupomLojaSitef");
        annuity.sitefTransactionData = localStorage.getItem("dadosSitef");
        this._memberAnnuityService
            .createOrEdit(annuity)
            .finally(() => {
                this.saving = false;
                this.clearSitefStorage();
            })
            .subscribe(
                (result) => {
                    if (result.memberAnnuityId > 0) {
                        //this._memberAnnuityId = result.memberAnnuityId;
                        annuity.annuity.id = result.memberAnnuityId;
                    }

                    if (!result.success) {
                        this.message.warn(this.l(result.message));
                    } else {
                        if (annuity.annuity.id > 0 && !finish) {
                            this.pay(annuity.annuity.id);
                        } else if (finish) {
                            this.congressWarnModal.show('Compra finalizada!', `<h4 class='text-primary-congress'><strong>${this.userLogged.name.split(' ')[0]},</strong> sua compra foi finalizada com sucesso! <br>Comprovantes foram enviados para o seu endereço de e-mail cadastrado no sistema SAESP. <br>A SAESP agradece, bom evento!<br></h4><br><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.</h5>`, true, 'congresso/home');
                            this._cartHelperService.finalizeCart();

                            let input = new EntityDtoOfInt64();
                            input.id = result.memberAnnuityId;

                            this.close();
                            this._router.navigate(["congresso/home"]);

                            this._ordersService
                                .sendConfirmPaymentEmail(input)
                                .subscribe((result) => {});
                            this.modalSave.emit(null);
                        }
                    }
                },
                (error) => {
                    // this.message.error(
                    //     "Ocorreu um erro ao salvar as informações da compra. Verifique se a compra da anuidade foi concluída antes de tentar novamente.<br>" +
                    //         error,
                    //     "Falha"
                    // );
                    this.paying = false;
                }
            );
    }

    clearSitefStorage(){
        localStorage.removeItem("cupomClienteSitef");
        localStorage.removeItem("cupomLojaSitef");
        localStorage.removeItem("dadosSitef");
        localStorage.removeItem("pending-transaction");
    }

    goToRoute(route: string, type: string) {
        this.triggerFalseClick();
        this.close();
        this._router.navigate([route+type]);
    }

    triggerFalseClick() {
        let el: HTMLElement = this.modalbody.nativeElement;
        el.click();
    }
}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/checkout/checkout-modal/checkout-modal.component.ts